import React from 'react';
import logoImage from '../../assets/logo.png';

interface LogoProps {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

/**
 * Компонент логотипа компании
 * Использует изображение из /src/assets/logo.png
 */
export const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
    const sizeClasses = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-10 h-10',
        xl: 'w-12 h-12'
    };

    return (
        <img
            src={logoImage}
            alt="AISER Logo"
            className={`${sizeClasses[size]} object-cover ${className}`}
        />
    );
};

